import React from 'react';
import ContactSection from '../ContactSection';

const ContactPage = () => {
  return (
    <div className="py-10">
      <ContactSection />
    </div>
  );
};

export default ContactPage;